module.exports = {"330205001":"中马街道","330205002":"白沙街道","330205003":"孔浦街道","330205004":"文教街道","330205005":"甬江街道","330205006":"庄桥街道","330205007":"洪塘街道","330205103":"慈城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330205.json
// module id = 957
// module chunks = 0